import Vue from 'vue'
import App from './App.vue'
import router from './plugins/router.js'
import store from './store/store'
import vuetify from '@/plugins/vuetify'
import i18n from '@/plugins/i18n'
import 'nprogress/nprogress.css'
import './assets/leaflet_custom.css'
import './assets/google_custom.css'
import httpClient from './api/httpClient'
import './plugins/vee-validate'
import VDigitalInputs from '@/components/custom/digitalInputs/VDigitalInputs'
import VBleSensor from '@/components/custom/VBleSensor'
import VSelectAll from '@/components/custom/VSelectAll'
import VImageUpload from '@/components/custom/VImageUpload'
import VImageArea from '@/components/custom/VImageArea'
import vdatepicker from '@/components/custom/VDateTextBox'
import ImagePicker from '@/components/custom/vehicles/IconsArea'
import TimePicker from '@/components/v2/customInputs/TimePicker'
import Checkbox from '@/components/v2/customInputs/Checkbox'
import TextInputList from '@/components/v2/customInputs/TextInputList'
import UseCasesInput from '@/components/v2/customInputs/UseCasesInput'
import ColorPicker from '@/components/v2/customInputs/ColorPicker'
import PasswordField from '@/components/v2/customInputs/PasswordField'
import VSelectDetachItem from '@/components/custom/VSelectDetachItem'
import VGuidKey from '@/components/custom/VGuidKey'
import VueCustomTextEditor from '@/components/v2/customInputs/VueCustomTextEditor'

Vue.component('VDigitalInputs', VDigitalInputs)
Vue.component('v-ble-sensor', VBleSensor)
Vue.component('VSelectAll', VSelectAll)
Vue.component('v-image-upload', VImageUpload)
Vue.component('v-date-field', vdatepicker)
Vue.component('v-imageArea', VImageArea)
Vue.component('v-image-picker', ImagePicker)
Vue.component('time-picker', TimePicker)
Vue.component('checkbox', Checkbox)
Vue.component('v-text-list', TextInputList)
Vue.component('v-use-cases-input', UseCasesInput)
Vue.component('v-custom-color-picker', ColorPicker)
Vue.component('v-password-field', PasswordField)
Vue.component('VSelectDetachItem', VSelectDetachItem)
Vue.component('v-guid-key', VGuidKey)
Vue.component('v-custom-text-editor', VueCustomTextEditor)

import * as VueGoogleMaps from 'vue2-google-maps'

import loggerPlugin from './utils/logger/logger'

import { UseCaseDirective } from './directives/UseCaseDirective'
import { DateTimeFilter } from './filters/DateTimeFilter'

Vue.directive('useCase', UseCaseDirective)
Vue.filter('datetime', DateTimeFilter)
Vue.use(loggerPlugin)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAwP5xx4XZqLioHF1FOb3zcSsF-OsdjY-k',
    libraries: 'places,drawing,geometry',
    language: i18n.locale.split('-')[0]
  },
  installComponents: true
})

Vue.config.productionTip = false

store.strict = false

Vue.prototype.$formBuilderAxios = httpClient
Vue.prototype.eventBus = new Vue()

new Vue({
  router,
  store,
  vuetify,
  i18n,
  //Automatsko logovanje prethodno ulogovanog usera pri refreshu stranice
  created() {
    const userString = localStorage.getItem('user') // grab user data from local storage
    if (userString) {
      // check to see if there is indeed a user
      const userData = JSON.parse(userString) // parse user data into JSON
      this.$store.commit('user/SET_USER_DATA', userData) // restore user data with Vuex
    }
  },
  render: h => h(App)
}).$mount('#app')
